import { writable } from 'svelte/store';
import httpRequest from './httpRequest';

const getOneUser = async (uid) => {
    return await httpRequest.get(`/user/${uid}`)
}

const updateOneUser = async (uid, data) => {
    return await httpRequest.post(`/user/${uid}`, data)
}

const updateOneOnBoardingUser = async (uid, data) => {
    return await httpRequest.put(`/user/${uid}`, data)
}

const getAllUsers = async () => {
    let users = await httpRequest.get('/user')

    return users
}

const getAppsFromOneUser = async (uid) => {
    return await httpRequest.get(`/user/${uid}/app`)
}


export default {
    getOneUser,
    updateOneUser,
    updateOneOnBoardingUser,
    getAllUsers,
    getAppsFromOneUser
} 